import React, { useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { AppContext, AppContextType } from 'context/AppContext';
import AvatarWrapper from 'components/Common/AvatarWrapper';
import FWScienceLogo from '../../assets/images/fwscience-logo.png';

type CompanyLogoProps = {
    drawerOpen: boolean;
};

const CompanyLogo = ({ drawerOpen }: CompanyLogoProps): JSX.Element => {
    const { ownUser } = useContext(AppContext) as AppContextType;

    return (
        <Stack justifyContent="center" alignItems="center" spacing={2} sx={{ mt: 2, mb: drawerOpen ? 8 : 14 }}>
            {ownUser?.company?.name === 'Framework Science' ? (
                <img height={`${drawerOpen ? 72 : 40}px`} width={`${drawerOpen ? 72 : 40}px`} src={FWScienceLogo} alt="CompanyLogo" />
            ) : (
                <AvatarWrapper type="company" size={drawerOpen ? 'md' : 'semi'} url={ownUser?.company?.logo} />
            )}

            {drawerOpen && <Typography variant="subtitle1">{ownUser?.company?.name}</Typography>}
        </Stack>
    );
};

export default CompanyLogo;
